import React, { useEffect } from 'react';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import Page404 from '@r1-frontend/ui-react/components/layouts/page404';
import Page500 from '@r1-frontend/ui-react/components/layouts/page500';

interface IErrorContainer {
    statusCode: number,
}

const ErrorContainer = ({ statusCode }: IErrorContainer) => {
    useEffect(() => {
        dataLayerPush({
            event: 'UAevent',
            category: `${statusCode} error`,
            action: window.location.href,
        });
    }, [statusCode]);

    return <>
        {statusCode === 500 && <Page500/>}
        {statusCode === 404 && <Page404 bgImage='/static/images/errorPages/404/bg.jpg'/>}
    </>;
};

export default ErrorContainer;
